import React from "react";
import ReactTooltip from "react-tooltip";
import withStyles from "@material-ui/core/styles/withStyles";
import { Help } from "@material-ui/icons";
import { Box, Typography } from "@material-ui/core";
import { useStyles } from "./dashboardStyles";

function HelpText({
  className = "",
  item = null,
  note = "",
  onClick = {},
  tooltip = "",
}) {
  return (
    <Box
      className={`${className} cursorPointer`}
      display={"flex"}
      data-tip={tooltip}
      item={item}
      onClick={() => onClick(item)}
    >
      <Typography variant="body2">{note}</Typography>
      {tooltip && (
        <>
          <Help style={{ height: "24px" }} />
          <ReactTooltip html={true} />
        </>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(HelpText);
